<template>
  <TwinPanel title="Log In">
    <template v-slot:form>
      <b-form :novalidate="true" class="form" @submit="onSubmit">
        <b-alert v-for="error in errors" :key="error" variant="danger" :show="true">
          {{ error }}
        </b-alert>
        <b-form-group label="Email" label-for="userEmail" :state="emailValid">
          <b-form-input
            id="userEmail"
            v-model="user.email"
            debounce="350"
            required
            :state="emailValid"
          />
          <b-form-invalid-feedback :state="emailValid">
            This doesn't look like an email to me...
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Password" label-for="userPassword">
          <b-form-input
            id="userPassword"
            v-model="user.password"
            type="password"
            required
            :state="null"
          />
        </b-form-group>

        <b-button class="mt-1 mb-3" type="submit" variant="primary"
                  :pressed="submitting"
                  :disabled="submitting || !emailValid || !user.password">
          Log In
        </b-button>

        <b-form-group>
          <div class="d-flex justify-content-between">
            <a :href="resolve('user.password_reset')"
               @click="navigate('user.password_reset', $event)">Forgot your password?</a>
            <a :href="resolve('user.register')"
               @click="navigate('user.register', $event)">Create an account</a>
          </div>
        </b-form-group>
      </b-form>
    </template>
    <template v-slot:text>
      <h4>Couldn't get enough of our heuristic evaluations? Log in and let's get going.</h4>
    </template>
  </TwinPanel>
</template>

<style lang="scss" scoped>
    .form {
        margin: 0 auto;
        max-width: 550px;
    }
</style>

<script>
    import isEmail from 'validator/lib/isEmail'
    import apiMixin from "../../utils/api"
    import TwinPanel from "./utils/TwinPanel"

    export default {
        name: 'UserLogin',
        components: {TwinPanel},
        mixins: [apiMixin],
        data() {
            return {
                user: {},
                success: false,
                errors: [],
                submitting: false,
                submitted: false,
                forgottenPasswordUrl: `${process.env.VUE_APP_API_BASE}/password/reset/`
            }
        },
        computed: {
            emailValid() {
                if (!this.user.email) {
                    return null
                }
                return isEmail(this.user.email)
            }
        },
        async created() {
            let maybeReroute = val => {
                if (val) {
                    this.navigate('site.list')
                }
            }
            this.$store.watch(
                (state, getters) => getters['user/loggedIn'],
                (newValue) => {
                    maybeReroute(newValue)
                },
            )
            maybeReroute(this.$store.getters['user/loggedIn'])
        },
        methods: {
            async onSubmit(e) {
                e.preventDefault()
                this.submitted = true
                return this.withLoading(async () => {
                    try {
                        await this.post("/api/users/me/session/", this.user)
                        await this.$store.dispatch('user/getDetails', this)

                        if (this.$gtm.enabled()) {
                            this.$gtm.trackEvent({
                                event: 'login',
                                value: this.user.email,
                            })
                        }

                        await this.$router.push({name: 'site.list'})
                    } catch (e) {
                        this.catchApiError(e, false)
                    }
                }, 'submitting')
            }
        }
    }
</script>


